import type { ForgotPasswordDraft } from './forgot-password.model';

/** Field-level validation errors, keyed by draft field name. Empty = valid. */
export type ValidationErrors = Partial<Record<keyof ForgotPasswordDraft, string>>;

/**
 * Pure business validation for the forgot-password draft. The only rule is a
 * non-empty email; no format regex: the backend owns email validation, and the
 * original page relied on the same non-empty gate. No React, no Redux.
 */
export function validateDraft(draft: ForgotPasswordDraft): ValidationErrors {
  const errors: ValidationErrors = {};
  if (!draft.email.trim()) errors.email = 'An email address is required.';
  return errors;
}
